import { observer } from 'mobx-react-lite';
import { BaseQueueCell } from '../../../../queues/components/base-queue-cell';
import { BoloQueueRowData } from '../../../../socket/stream-types';
import { colors } from '../../../../colors/colors';

export const BoloPriorityCell = observer(function PriorityCell({
    data,
}: {
    data: BoloQueueRowData;
}): React.ReactElement {
    //TODO: Should this flash like events?
    return (
        <BaseQueueCell
            alignment="CENTER"
            data-testid="PRIORITY"
            backgroundColor={data.isPriority1 ? colors.queuePriority : undefined}
        >
            {data.priority}
        </BaseQueueCell>
    );
});
